import { useCallback, useEffect, useRef } from 'react';
import '../styles/styles.css';

// https://d3js.org/
import * as d3 from 'd3';
import { geoRobinson } from 'd3-geo-projection';

function App() {
  const map = useRef();
  const initMap = useCallback(() => {
    // window.Datamap comes from public/vendor/datamaps.js, loaded as a classic script (see index.html)
    map.current = new window.Datamap({
      data: {
        // http://www.worldatlas.com/aatlas/ctycodes.htm
        AUT: { fillKey: 'david' },
        ARG: { fillKey: 'david' },
        CHE: { fillKey: 'david' },
        DEU: { fillKey: 'david' },
        ECU: { fillKey: 'davidalejandro' },
        CHL: { fillKey: 'davidalejandro' },
        MEX: { fillKey: 'davidalejandro' },
        ESP: { fillKey: 'david' }
      },
      element: document.querySelector('.map'),
      fills: {
        david: '#F58220',
        davidalejandro: '#A05FB4',
        defaultFill: 'rgba(188, 213, 209, 1.0)'
      },
      geographyConfig: {
        highlightOnHover: false,
        popupOnHover: true
      },
      responsive: true,
      setProjection(element) {
        const projection = geoRobinson()
          .center([0, 0])
          .scale(element.offsetWidth / 6)
          .translate([element.offsetWidth / 2, element.offsetHeight / 2]);
        const path = d3.geoPath().projection(projection);
        return { path, projection };
      }
      // projection: 'georobinson',
    });
  }, []);
  useEffect(() => {
    initMap();
    window.addEventListener('resize', event => {
      map.current.resize(event);
    });
  }, [initMap]);

  return (
    <div className="app">
      <div className="map" />
      <div className="legend">
        <div>
          <span
            className="indicator"
            style={{
              backgroundColor: '#A05FB4',
              display: 'inline-block',
              width: '20px',
              height: '20px'
            }}
          />{' '}
          <span className="label">David Alejandro</span>
        </div>
        <div>
          <span
            className="indicator"
            style={{
              backgroundColor: '#F58220',
              display: 'inline-block',
              width: '20px',
              height: '20px'
            }}
          />{' '}
          <span className="label">&quot;just&quot; David</span>
        </div>
      </div>
      <noscript>Your browser does not support JavaScript!</noscript>
    </div>
  );
}

export default App;
